import React, { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";

export default function SearchResults() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  // ✅ Get query param
  const queryParams = new URLSearchParams(location.search);
  const query = queryParams.get("query")?.toLowerCase() || "";

  useEffect(() => {
    // ✅ If no query, go home
    if (!query) {
      navigate("/");
      return;
    }

    const fetchCourses = async () => {
      try {
        const response = await fetch("https://agepcoatings.com/getcourses");
        const data = await response.json();
        setCourses(data);
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, [query, navigate]);

  if (loading) {
    return <p className="text-center my-5">Loading search results...</p>;
  }

  // ✅ Filter courses by courseName / courseDescription / levelsData
  const filtered = courses.filter((course) => {
    const name = course.courseName?.toLowerCase() || "";
    const description = course.courseDescription?.toLowerCase() || "";

    // 🔍 Match inside levelsData also
    const levelMatch = course.levelsData?.some((level) => {
      const lvl = level.level?.toString().toLowerCase() || "";
      const lvlName = level.levelName?.toLowerCase() || "";
      const lvlDesc = level.levelDescription?.toLowerCase() || "";

      return (
        lvl.includes(query) ||
        (`level ${lvl}`.includes(query) && query !== "") ||
        lvlName.includes(query) ||
        lvlDesc.includes(query)
      );
    });

    return name.includes(query) || description.includes(query) || levelMatch;
  });

  return (
    <section className="container course-wrapper py-5">
      <h3 className="fw-bold mb-4">Search Results for "{query}"</h3>
      <Link to="/" className="btn rounded-5" style={{textDecoration:"none", color:"#fef5ee",background:"#ee5e23"}}>
        <i className="bi bi-house-door me-1"></i> Back Home
      </Link>
      <div className="row g-4 justify-content-center">
        {filtered.length > 0 ? (
          filtered.map((course) => (
            <div
              className="col-lg-4 col-md-6 d-flex justify-content-center"
              key={course._id}
            >
              <div className="course-card">
                <div className="position-relative">
                  <img
                    src={course.image}
                    alt={course.courseName}
                    className="course-img"
                  />
                </div>

                <div className="course-card-body">
                  <div className="d-flex align-items-center mb-2 small flex-wrap">
                    <span className="me-3">
                      <i className="bi bi-people-fill me-1"></i>
                      {course.enrolledUsers || 0} Enrolled
                    </span>
                    <span className="d-flex align-items-center mx-3">
                      <i className="bi bi-star-fill text-warning"></i>
                      <span className="fw-bold">{course.rating || "0.0"}</span>
                    </span>
                  </div>

                  <h6 className="fw-bold">{course.courseName}</h6>
                  <p className="text-muted small course-description">
                    {course.courseDescription}
                  </p>

                  {/* ✅ Show Levels inside course */}
                  <div className="row g-3 mt-3">
                    {course.levelsData?.map((level) => (
                      <div key={level.levelId} className="col-12">
                        <div className="course-card-level border p-2 rounded shadow-sm">
                          <img
                            src={level.levelimage || "/placeholder.png"}
                            alt={level.levelbadge}
                            className="course-card-img-level mb-2"
                          />
                          <span className="badge text-dark border mb-2">
                            {level.level}
                          </span>
                          <h6>{level.levelName}</h6>
                          <p className="text-muted small">
                            {level.levelDescription}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="d-flex justify-content-between mt-3">
                    <Link to={`/courses/${course.courseId}`}>
                      <button className="course-details rounded-5">
                        Course Details
                      </button>
                    </Link>
                    <button className="course-btn btn-sm">
                      <Link
                        to="/expofinterst"
                        style={{ textDecoration: "none", color: "#fef5ee" }}
                      >
                        Register Now
                      </Link>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-muted">
            No courses found for "{query}".
          </p>
        )}
      </div>
    </section>
  );
}
